import 'css/common.scss';
import 'css/rtl.scss';
import './app.scss';

export const AppTemplate = (model) => {
	/* html */
	const popover = `
		<div class="engt-popover-overlay" id="engtPopoverOverlay">
			<div class="engt-popover" id="engtPopover"></div>
		</div>
	`;

	/* html */
	const overlay = `
		<div class="engt-media-preview engt-media-controls-wrapper engt-open-preview engt-hidden" id="engtMediaOverlay">
		</div>
	`;

	/* html */
	const html = `
		<div class="engt-wrapper" id="engtWrapper">
        	<pop-up></pop-up>
			${popover}
			${overlay}
		</div>
	`;

	return html;
};
